export default "__VITE_ASSET__BndoU5P2__"